<template>
    <section class="products container pb-5 pt-lg-8 pt-5">
        <PageLoader v-if="!loading" />
        <div v-if="loading">
            <!-- <h2 class="mb-4 mb-md-4 fw-bold text-primary text-center">
                {{ $t("our-products") }}
            </h2> -->
            <div class="row">
                <!-- <div class="col"></div>
                <div class="col-md-auto d-flex justify-content-center">
                  <div class="categories-container bg-secondary rounded-4">
                    <router-link
                    :to="{
                      name: 'products'
                      }"
                    :class="{'active-category': !$route.query.category  }"
                    class="btn  rounded-4  px-4 py-2">
                    {{$t('all')}}
                    </router-link>
                    <router-link
                        v-for="category in categories.slice(0, 2)"
                        :key="category.id"
                        :to="{
                            name: 'products',
                            query: { category: category.slug },
                        }"
                        :class="{'active-category': category.slug === $route.query.category }"
                        class="btn  rounded-4  px-4 py-2"
                    >
                        {{ category.name }}
                    </router-link>
                  </div>
                </div> -->
                <div class="col d-flex justify-content-center pt-4 pt-md-0">
                </div>
            </div>
        </div>
        <div
            v-if="loading"
            class="products row pt-5"
        >
            <div class="col-12 col-md-3 pb-5">
              <h2 class="fw-bold">
                <i class="fa-solid fa-sliders"></i>
                <span class="mx-2">
                  {{ $t('filters') }}
                </span>
              </h2>
              <div class="search-input my-3">
                <input
                  id="search"
                  v-model="searchString"
                  class="form-control search rounded-3 bg-secondary mb-3"
                  :placeholder="$t('search')"
                />
                <label class="search-icon" for="search"><i class="fa-solid fa-magnifying-glass"></i></label>
              </div>
              <div class="filters py-1">
                <div class="heading d-flex align-items-center py-2">
                  <img src="@/assets/images/categories.svg" width="20" height="20" alt="">
                  <p class="mx-2">
                    {{ $t('categories') }}
                  </p>
                </div>
                <div class="categories d-flex flex-md-column flex-wrap gap-3 gap-md-2">
                  <div class="category" v-for="category in categories" :key="category.id">
                    <input :id="'category-'+ category.id" :checked="selectedCategory === category.slug" class="form-check-input" type="checkbox" @change="changeSelectedCategory(category.slug)">
                    <label :for="'category-'+ category.id" class="mx-2">{{category.name}}</label>
                  </div>
                </div>
                <div class="categories">
                  <div
                    v-for="attribute in getCategoriesBySlug(selectedCategory)?.attributes"
                    :key="attribute.key"
                  >
                    <div class="heading d-flex align-items-center py-2">
                      <img :src="attribute.image.url" width="auto" height="20" alt="">
                      <p class="mx-2">{{attribute.name}}</p>
                    </div>
                    <div class="d-flex flex-wrap flex-md-column gap-4 gap-md-2">
                      <div v-for="(value, i) in attribute.options" :key="value" class="category categories ">
                        <input :id="'attribute-'+ i" :checked="selectedValues.includes(value)" class="form-check-input" type="checkbox" @change="changeSelectedAttributes(value, attribute.id)">
                        <label :for="'attribute-'+ i" class="mx-2" v-html="value"></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-none d-md-block col-auto px-4">
              <div class="aside-border"></div>
            </div>
            <div ref="products"  class="col px-1">
              <h2 class="fw-bold ">{{$t('products-list')}}</h2>
              <div class="active-filters row align-items-start">
                <div class="col-auto">
                  <p class="heading py-2">{{ $t('active-filters') }}:</p>
                </div>
                <div  class="col-12 col-md h-100 py-2 d-flex flex-wrap gap-2 align-items-center">

                  <div v-if="selectedCategory" class="active-filter d-flex align-items-center ms-2">
                    <span class="filter-tag">{{getCategoriesBySlug(selectedCategory)?.name}}</span>
                    <i class="fa-solid fa-xmark ms-2" @click="changeSelectedCategory(selectedCategory)"></i>
                  </div>
                  <div v-for="value in selectedValues" :key="value + value" class="active-filter d-flex align-items-center">
                    <span class="filter-tag">{{value}}</span>
                    <i class="fa-solid fa-xmark ms-2" @click="changeSelectedAttributes(value)"></i>
                  </div>
                </div>
                <div class="col-auto">
                  <p class="clear py-2" @click="clear()">
                    {{ $t('clear-all') }}
                  </p>
                </div>
              </div>
              <div class="d-flex gap-5 justify-content-center justify-content-lg-start flex-wrap pt-4">
                <div v-if="searchLoading" class="linear-loader"></div>
                <div
                  v-for="(product, i) in filteredProducts"
                  :key="product.id"
                >
                    <ProductCard
                      :product="product"
                      data-aos="zoom-out"
                      data-aos-duration="250"
                      data-aos-anchor=".products"
                      :data-aos-delay="i * 150"
                    />
                </div>
                <div
                  v-if="!filteredProducts.length && searchString ? true : false"
                  class="text-center col-12"
              >
                  <h2 class="text-primary fw-bold">No Result</h2>
                  <img
                      src="../assets/images/no-results.png"
                      class="text-center"
                      width="100"
                      alt=""
                  />
              </div>
              </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ProductCard from '../components/ProductCard.vue'
import PageLoader from '@/components/PageLoader.vue'
import AOS from 'aos'
export default {
  name: 'ProductsView',
  components: { PageLoader, ProductCard },
  data () {
    return {
      searchString: '',
      loading: true,
      categoryProducts: [],
      filters: [],
      selectedCategory: '',
      selectedAttributes: [],
      selectedValues: [],
      searchLoading: false,
      filterProducts: []
    }
  },
  watch: {
    '$route' (val) {
      this.$nextTick(() => {
        window.scrollTo({
          behavior: 'smooth', top: this.$refs.products.getBoundingClientRect().top + window.scrollY - 100
        })
      })
    }
  },
  computed: {
    ...mapState({
      products: (state) => state.products.products,
      categories: (state) => state.categories.categories
    }),
    getCategoryById () {
      return id => this.categories.find(v => v.id === id)
    },
    ...mapGetters({
      getProductBySlug: 'products/getBySlug',
      getCategoriesBySlug: 'categories/getBySlug'
    }),

    filteredProducts () {
      return this.filterProducts
        .filter((product) =>
          product.name
            .toLocaleLowerCase()
            .includes(this.searchString.toLocaleLowerCase())
        )
    }
  },
  methods: {
    changeSelectedCategory (slug) {
      if (this.selectedCategory !== slug) {
        this.selectedCategory = slug
      } else {
        this.selectedCategory = null
      }
      this.selectedAttributes = []
      this.selectedValues = []
      this.getProducts()
      this.$router.replace({ name: 'products', query: { category: this.selectedCategory } })
    },
    changeSelectedAttributes (value, attributeId) {
      const valueIndex = this.selectedValues.findIndex(v => v === value)
      if (valueIndex === -1) {
        this.selectedValues.push(value)
      } else {
        this.selectedValues.splice(valueIndex, 1)
      }
      if (attributeId) {
        const index = this.selectedAttributes.findIndex(v => v === attributeId)
        if (index === -1) {
          this.selectedAttributes.push(attributeId)
        } else if (this.selectedValues.length === 0) {
          this.selectedAttributes.splice(index, 1)
        }
      }
      this.$router.replace({ name: 'products', query: { category: this.selectedCategory, values: this.selectedValues, attributes: this.selectedAttributes } })
      this.getProducts()
    },
    getProducts () {
      this.searchLoading = true
      this.filterProducts = []
      const filters = {
        attributesValues: this.selectedValues,
        attributesIds: this.selectedAttributes,
        categorySlug: this.selectedCategory
      }
      this.$store.dispatch('products/filterProducts', filters).then((products) => {
        this.searchLoading = false
        this.filterProducts = products
      })
    },
    clear () {
      this.selectedAttributes = []
      this.selectedCategory = null
      this.selectedValues = []
      this.filterProducts = []
      this.getProducts()
    }
  },

  created () {
    AOS.init()
    const promises = []
    if (!this.products.length) {
      this.loading = false
      promises.push(this.$store.dispatch('products/fetchAll')).then(() => {

      })
    }
    if (!this.categories.length) {
      this.loading = false
      promises.push(this.$store.dispatch('categories/fetchAll'))
    }
    Promise.all(promises).finally(() => {
      this.loading = true
      // this.categoryProducts = this.$route.query?.category ? this.products.filter(v => v.categoriesIds.includes(this.getCategoriesBySlug(this.$route.query.category)?.id)) : this.products
      // const filters = this.$route.query.category
      // if (filters) {
      //   if (Array.isArray(filters)) {
      //     this.filter = filters
      //   } else {
      //     this.filters.push(filters)
      //   }
      // }
      this.selectedCategory = this.$route.query.category
      const values = this.$route.query.values
      if (values) {
        if (Array.isArray(values)) {
          this.selectedValues = values
        } else {
          this.selectedValues.push(values)
        }
      }
      const attributes = this.$route.query.attributes
      if (attributes) {
        if (Array.isArray(attributes)) {
          this.selectedAttributes = attributes
        } else {
          this.selectedAttributes.push(attributes)
        }
      }
      this.getProducts()
    })
  }
}
</script>

<style lang="scss" scoped>
.products {
    min-height: 80vh;
}
.aside-border{
  width:5px;
  height: 100%;
  border-left: 4px solid rgb(214, 214, 214);
}
.search-input{
  position: relative;
  .search {
    width: 100%;
  }
  .search-icon{
    position: absolute;
    right: 15px;
    color: rgb(182, 182, 182);
    top: 50%;
    transform: translateY(-50%);
  }
}
.clear{
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}
.active-filters{
  .heading{
    font-size: 18px;
    font-weight: 600;
  }
  .active-filter{
    padding: 6px 14px;
    font-size: 14px;
    background: var(--bs-primary);
    color: white;
    border-radius: var(--bs-border-radius-xl);
    i{
      cursor: pointer;
    }
  }
}
.linear-loader {
  position: relative;
  width: 100%;
  height: 4px;
  background-color: #e0e0e0;
  overflow: hidden;
  border-radius: 4px;
}

.linear-loader::before {
  content: "";
  position: absolute;
  height: 100%;
  width: 40%;
  background-color: #1976d2; /* Vuetify primary color */
  animation: loadingAnim 1.5s infinite ease-in-out;
  border-radius: 4px;
}

@keyframes loadingAnim {
  0% {
    left: -40%;
  }
  50% {
    left: 50%;
    width: 60%;
  }
  100% {
    left: 100%;
    width: 40%;
  }
}
.filters{
  .heading{
    font-size: 22px;
    font-weight: 700;
  }
  .categories{
    .category{
      display: flex;
      align-items: center;
      input{
        cursor: pointer;
        width: 20px;
        height: 20px;
        margin: 0;
      }
      input:checked{
        background-color: var(--bs-primary);
      }
      label{
        font-size: 18px;
        font-weight: 500;
        cursor: pointer;
      }
    }
  }
}

/*.card {
    width: 200px;
    .card-img-container {
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgb(250, 249, 249);
        height: 300px;
        width: 100%;
    }
    .card-img-top {
        height: 250px;
        width: 75px;
    }
}*/
/*.categories-container{
  border-radius: 2rem;
  .btn{
    color:grey;
    font-weight: 500;
    &:hover{
      color:#3d769f;
    }
    &:focus{
      border: none;
    }
  }
  .active-category {
    background: #3d769f;
    color:#F6F6F6;
    &:hover{
      color: #f6f6f6;
    }
  }
}*/
input::placeholder {
    color: #b9b9b9;
}
</style>
